import { render, staticRenderFns } from "./import-incentive.vue?vue&type=template&id=31180b65&scoped=true&"
import script from "./import-incentive.vue?vue&type=script&lang=js&"
export * from "./import-incentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31180b65",
  null
  
)

export default component.exports